import { render, staticRenderFns } from "./literature.vue?vue&type=template&id=0e4dbc9f"
import script from "./literature.vue?vue&type=script&lang=js"
export * from "./literature.vue?vue&type=script&lang=js"
import style0 from "./literature.vue?vue&type=style&index=0&id=0e4dbc9f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports